var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5768 18.1859C13.5819 18.191 13.5891 18.1933 13.5962 18.1922L14.8298 17.9919C15.533 17.8787 16.1878 17.5473 16.689 17.0381L17.8449 15.8821C18.3704 15.3567 18.3704 14.5079 17.8449 13.9825L15.1854 11.323C14.66 10.7976 13.8112 10.7976 13.2858 11.323C12.2188 12.39 10.4889 12.39 9.42189 11.323L6.916 8.81711C5.849 7.75012 5.849 6.02018 6.916 4.95318C7.44143 4.42775 7.44143 3.57898 6.916 3.05355L4.25652 0.394072C3.73109 -0.131357 2.88232 -0.131357 2.35689 0.394072L1.20094 1.55002C0.69168 2.05928 0.360255 2.70596 0.247086 3.40923L0.0449977 4.65409C-0.13284 5.7292 0.222835 6.82856 0.998854 7.5965L10.6263 17.224C11.3916 17.9892 12.4859 18.3451 13.5575 18.1796C13.5645 18.1785 13.5717 18.1808 13.5768 18.1859Z",
    fill: "#474C55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTel2);
export default __webpack_public_path__ + "static/media/icon_tel2.287c33b2e0d69ae5f83ca979e9de5d25.svg";
export { ForwardRef as ReactComponent };